import { Component, OnInit } from '@angular/core';
import { MappedStammdatenGesetzlicherVertreter, WithStammdatenIndex, WizardListPageBaseComponent } from '@utils-lib';
import { GesetzlicherVertreter, GesetzlicherVertreterAngaben } from '@nachdigal';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'common-ui-gesetzlicher-vertreter-angaben',
    templateUrl: './gesetzlicher-vertreter-angaben.component.html',
    styleUrls: ['./gesetzlicher-vertreter-angaben.component.scss']
})
export class GesetzlicherVertreterAngabenComponent extends WizardListPageBaseComponent<GesetzlicherVertreterAngaben> implements OnInit {

    static nutzdatenPath = 'gesetzlicherVertreterAngaben';
    static route = 'gesetzlicher-vertreter-angaben';

    constructor(protected readonly activatedRoute: ActivatedRoute,
        private readonly router: Router,
        private readonly translateService: TranslateService) {
        super(activatedRoute);
        this.maxAllowed = 9;
    }

    public ngOnInit(): void {
        super.ngOnInit();

        const stammdatenLength = this.stammdaten?.gesetzlicherVertreter?.length;
        if (stammdatenLength > this.maxAllowed) {
            this.showMaxLimitHint = true;
        }
        if (!this.data.gesetzlicheVertreter) {
            this.data.gesetzlicheVertreter = [];
            const pageIsTouched = this.activatedRoute.parent?.snapshot.data.taskData.metadaten.pages.gesetzlicherVertreterAngaben.touched;
            if (stammdatenLength !== 0 && !pageIsTouched) {
                for (let i = 0; i < stammdatenLength && i < this.maxAllowed; i++) {
                    this.fillVertreterFromStammdaten(this.stammdaten.gesetzlicherVertreter[i]);
                    const addressMappingRules = new Map<string, unknown | Array<unknown>>([
                        ['inlandsadresse', this.stammdaten?.gesetzlicherVertreter[i].value.inlandsadressen],
                        ['auslandsadresse', this.stammdaten?.gesetzlicherVertreter[i].value.auslandsadressen],
                        ['postfachadresse', this.stammdaten?.gesetzlicherVertreter[i].value.postfachadressen],
                        ['kommunikationsmittel.telefonnummern[0]',
                            this.stammdaten?.gesetzlicherVertreter[i].value.kommunikation?.telefonnummern],
                        ['kommunikationsmittel.internet', this.stammdaten?.gesetzlicherVertreter[i].value.kommunikation?.internetadressen]
                    ]);
                    this.stammdatenService.assignStammdatenIfDeterministic(addressMappingRules, this.data.gesetzlicheVertreter[i]);
                }
            }
        }
    }

    public addGesetzlicherVertreter(): void {
        this.data.gesetzlicheVertreter.push({ gesetzlicherVertreter: {} });
        this.selectedIndex = this.data.gesetzlicheVertreter.length - 1;
    }

    public removeGesetzlicherVertreter(index: number): void {
        this.data.gesetzlicheVertreter.splice(index, 1);
    }

    public getDescription(gesetzlicherVertreter: GesetzlicherVertreter): string {
        if (gesetzlicherVertreter?.gesetzlicherVertreter?.nachname && gesetzlicherVertreter?.gesetzlicherVertreter?.vorname) {
            return `${gesetzlicherVertreter.gesetzlicherVertreter.vorname} ${gesetzlicherVertreter.gesetzlicherVertreter.nachname}`;
        } else {
            return this.translateService.instant('COMMON_UI.FRAGEBOGEN.GESETZLICHER_VERTRETER.NEW_GESETZLICHER_VERTRETER');
        }
    }

    public onGesetzlicheVertreterPicked(gesetzlicherVertreter: WithStammdatenIndex<MappedStammdatenGesetzlicherVertreter>): void {
        this.fillVertreterFromStammdaten(gesetzlicherVertreter);
    }

    public fillVertreterFromStammdaten(gesetzlicherVertreter: WithStammdatenIndex<MappedStammdatenGesetzlicherVertreter>): void {
        const current = {
            gesetzlicherVertreter: gesetzlicherVertreter.value.personenstammDaten,
            steuernummer: gesetzlicherVertreter.value.steuernummer,
            gesetzlicherVertreterWeitereAngaben: gesetzlicherVertreter.value.personWeitereAngaben,
            stammdatenIndex: gesetzlicherVertreter.stammdatenIndex
        };
        this.data.gesetzlicheVertreter.push(current);
        this.selectedIndex = this.data.gesetzlicheVertreter.length - 1;
    }

    protected getStammdatenMappingRules(): Map<string, unknown> {
        return new Map<string, unknown | Array<unknown>>();
    }

}
